import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import "./OrderSummary.css";
import CouponModal from "./CouponModal";
import axios from "axios";
import { API_BASE_URL } from "../utils";
import { GoInfo } from "react-icons/go";
import { FaDirections } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { MdOutlineTimer } from "react-icons/md";
import { BiDrink } from "react-icons/bi";

import { HiUsers } from "react-icons/hi";
import BlueCardInfoCard from "./comp/BlueCardInfoCard";
import VenueInfoComp from "./comp/VenueInfoComp";
import PlatformChargesTooltip from "./comp/PlatformChargesTooltip";
import iziToast from "izitoast";
import Loader from "../Loader/Loader";

const data = {
  friendsText: "Rakesh Suresh and 3 of your friends have partied here.",
  originalPrice: 12000,
  discountedPrice: 8000,
  partyDate: "10 April 2025",
  timeSlot: "10PM Onwards",
  packageType: "IMFL + FOOD",
  pax: "10 Guests",
  perPerson: 1000,
  venue: "F-Bar",
  rating: 4.1,
  reviews: 3,
  address: "DLP Phase 3, Gurugram - 122010",
  distance: 1.2,
};

const baseurl = `${API_BASE_URL}/master/assets/uploads/`;

const OrderSummary = () => {
  const [useCarrot, setUseCarrot] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const [availableCoupons, setAvailableCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewMore, setViewMore] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [initialValuesCoupon, setInitialValuesCoupon] = useState(null);
  const [paymentGateway, setPaymentGateway] = useState("razorpay");
  const [processing, setProcessing] = useState(false); // ✅ Added
  const [orderID, setOrderID] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const sourcePage = searchParams.get("sourcePage");

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");

  // ✅ Calculate amounts safely
  const calculateAmounts = useCallback(() => {
    if (!orderData) return null;

    const num = (val) => parseFloat(val) || 0;

    const baseAmount = num(orderData.total_amount);
    const payableAmount = num(orderData.payable_amount);
    const netPayableAmount = num(orderData.net_payable_amount);
    const dueAmount = num(orderData.due_amount);
    const usableCarrot = num(orderData.usableCarrot);
    const platformFee = num(orderData.platform_fee);
    const clubAdvance = num(orderData.club_advance_amount);
    const pwCommAmount = num(orderData.pw_total_comm_amount);

    // ✅ Coupon discount
    let couponDiscount = 0;

    console.log("selectedCoupon", selectedCoupon);
    if (selectedCoupon) {
      const minSpent = num(selectedCoupon.min_spent);
      if (payableAmount >= minSpent) {
        if (selectedCoupon.discount_type === "percent") {
          couponDiscount = (payableAmount * num(selectedCoupon.discount)) / 100;
          if (selectedCoupon.capping) {
            couponDiscount = Math.min(
              couponDiscount,
              num(selectedCoupon.capping)
            );
          }
        } else {
          couponDiscount = num(selectedCoupon.discount);
        }
      }
    }

    // ✅ Carrot discount
    const carrotDiscount = useCarrot
      ? Math.min(usableCarrot, payableAmount * 0.1)
      : 0;

    // ✅ Final Payable
    const finalPayableAmount =
      netPayableAmount -
      carrotDiscount -
      (initialValuesCoupon?.id === selectedCoupon?.id ? 0 : couponDiscount);

    return {
      baseAmount,
      payableAmount,
      netPayableAmount,
      dueAmount,
      usableCarrot,
      platformFee,
      clubAdvance,
      pwCommAmount,
      carrotDiscount,
      couponDiscount,
      finalPayableAmount: Math.max(0, finalPayableAmount),
    };
  }, [orderData, useCarrot, selectedCoupon, initialValuesCoupon]);

  const amounts = calculateAmounts();

  // ✅ Create Order
  const createOrder = useCallback(
    async (latitude, longitude) => {
      if (!id || !userData?.id) {
        setError("Missing required parameters");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append("bid_id", id);
        formData.append("user_id", userData.id);
        formData.append("amount", null);
        formData.append("type", "discount");
        formData.append("latitude", latitude);
        formData.append("longitude", longitude);

        const url =
          sourcePage === "table"
            ? `${API_BASE_URL}/master/APIs/ClubTable/placeOrder`
            : `${API_BASE_URL}/master/APIs/ClubPackage/placeOrder`;

        const response = await axios.post(url, formData);
        const responseData = response.data;

        if (responseData.status === true && responseData.data?.length > 0) {
          setOrderData(responseData.data[0]);

          setOrderID(responseData.data[0].order_id);

          // ✅ Applied coupon parse
          if (
            responseData?.applied_coupon &&
            responseData.applied_coupon !== "{}"
          ) {
            const parsedCoupon =
              typeof responseData.applied_coupon === "string"
                ? JSON.parse(responseData.applied_coupon)
                : responseData.applied_coupon;

            setSelectedCoupon(parsedCoupon);
            setInitialValuesCoupon(parsedCoupon);
          } else {
            setSelectedCoupon(null);
            setInitialValuesCoupon(null);
          }
        } else {
          setError(responseData.msg || "Failed to create order");
        }
      } catch (error) {
        console.error("Order creation error:", error);
        if (error.code === "ECONNABORTED") {
          setError("Request timeout. Please try again.");
        } else if (error.response) {
          setError(`Server error: ${error.response.status}`);
        } else if (error.request) {
          setError("Network error. Please check your connection.");
        } else {
          setError("An unexpected error occurred.");
        }
      } finally {
        setLoading(false);
      }
    },
    [id, userData?.id, sourcePage]
  );

  // ✅ Coupon handling
  const handleCouponApply = (coupon) => {
    setSelectedCoupon(coupon);
    handleCouponApplyAPI(coupon);
    setShowModal(false);
  };

  const handleCouponApplyAPI = async (coupon, latitude, longitude) => {
    if (orderID === null) {
      return;
    }

    const formData = new FormData();
    formData.append("user_id", userData.id);
    formData.append("bid_id", id);
    formData.append("order_id", orderID);
    formData.append("coupon", coupon.code);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubPackage/applyCoupon`,
        formData
      );
      const responseData = response.data;

      console.log("Coupon applied successfully", responseData);
      if (responseData.res === "success") {
        createOrder(latitude, longitude);
      } else {
        setError(responseData.msg || "Failed to apply coupon");
      }
    } catch (e) {
      console.log(e);
      if (e.code === "ECONNABORTED") {
        setError("Request timeout. Please try again.");
      } else if (e.response) {
        setError(`Server error: ${e.response.status}`);
      } else if (e.request) {
        setError("Network error. Please check your connection.");
      } else {
        setError("An unexpected error occurred.");
      }
    }
  };

  const handleRemoveCouponAPI = async (latitude, longitude) => {
    if (orderID === null) {
      return;
    }

    const formData = new FormData();
    formData.append("user_id", userData.id);
    formData.append("bid_id", id);
    formData.append("order_id", orderID);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubPackage/removeCoupon`,
        formData
      );
      const responseData = response.data;

      console.log("Coupon removed successfully", responseData);
      if (responseData.status) {
        createOrder(latitude, longitude);
      } else {
        setError(responseData.msg || "Failed to remove coupon");
      }
    } catch (e) {
      console.log(e);
      if (e.code === "ECONNABORTED") {
        setError("Request timeout. Please try again.");
      } else if (e.response) {
        setError(`Server error: ${e.response.status}`);
      } else if (e.request) {
        setError("Network error. Please check your connection.");
      } else {
        setError("An unexpected error occurred.");
      }
    }
  };

  const handleRemoveCoupon = () => {
    setSelectedCoupon(null);
    handleRemoveCouponAPI();
  };

  const handleFetchCoupon = async () => {
    const formData = new FormData();
    formData.append("user_id", userData.id);
    formData.append("bid_id", id);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/ClubPackage/getAllCoupons`,
        formData
      );
      if (response.data?.all_coupons) {
        setAvailableCoupons(response.data.all_coupons);
      } else {
        setAvailableCoupons([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  // ✅ Proceed to checkout
  const handleProceedToCheckout = () => {
    if (!orderData?.order_id) {
      setError("Order ID not found");
      return;
    }
    handleCheckout();
  };

  // ✅ Checkout handler
  const handleCheckout = async () => {
    if (!orderData) {
      setError("Order details not found");
      return;
    }

    setProcessing(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append("order_id", orderData.order_id);
      formData.append("carrot_use", useCarrot ? "true" : "false"); // ✅ fixed
      formData.append("coupon_code", selectedCoupon?.code || "");
      formData.append("payment_gateway", paymentGateway);

      const url =
        sourcePage === "table"
          ? `${API_BASE_URL}/master/APIs/ClubTable/checkout`
          : `${API_BASE_URL}/master/APIs/ClubPackage/checkout`;

      const response = await axios.post(url, formData);
      const responseData = response.data;

      console.log("Checkout response:", responseData);

      if (responseData.status === true) {
        if (paymentGateway === "razorpay" && responseData.data) {
          initializeRazorpay(responseData.data);
        } else if (responseData.redirectUrl) {
          window.location.href = responseData.redirectUrl;
        } else {
          setError("Invalid payment data received for Razorpay.");
        }
      } else {
        setError(responseData.msg || "Payment initiation failed");
      }
    } catch (error) {
      console.error("Checkout error:", error);
      if (error.code === "ECONNABORTED") {
        setError("Request timeout. Please try again.");
      } else if (error.response) {
        setError(
          `Server error: ${error.response.data?.msg || error.response.status}`
        );
      } else if (error.request) {
        setError("Network error. Please check your connection.");
      } else {
        setError("An unexpected error occurred.");
      }
    } finally {
      setProcessing(false);
    }
  };

  // ✅ Razorpay init
  const initializeRazorpay = (paymentData) => {
    if (!window.Razorpay) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => openRazorpay(paymentData);
      script.onerror = () =>
        setError("Failed to load Razorpay. Please try again.");
      document.body.appendChild(script);
    } else {
      openRazorpay(paymentData);
    }
  };

  const openRazorpay = (paymentData) => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: paymentData.amount * 100,
      currency: "INR",
      name: "PartyWitty",
      description: `PartyWitty Booking - Order ${orderData?.order_id}`, // ✅ fixed
      order_id: paymentData.rzp_order_id,
      prefill: {
        name: userData.name || "",
        email: userData.email || "",
        contact: paymentData.userMobile || userData.mobile || "",
      },
      theme: {
        color: "#FF6B6B",
      },
      modal: {
        ondismiss: () => {
          setProcessing(false);
          setError("Payment cancelled by user");
        },
      },
      handler: async function (response) {
        try {
          const verified = await verifyRazorpayPayment(response);
          if (verified) {
            navigate(`/payment-done/${orderData?.order_id}`, {
              state: {
                orderId: orderData?.order_id,
                transactionId: response.razorpay_payment_id,
                razorpayOrderId: response.razorpay_order_id,
                signature: response.razorpay_signature,
              },
            });
          } else {
            setError("Payment verification failed. Please contact support.");
          }
        } catch (error) {
          console.error("Payment verification error:", error);
          setError("Something went wrong during payment verification.");
        }
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", (response) => {
      console.error("Razorpay payment failed:", response);
      setError(`Payment failed: ${response.error.description}`);
      setProcessing(false);
    });

    rzp.open();
  };

  // ✅ Verify Razorpay
  const verifyRazorpayPayment = useCallback(
    async (razorpayResponse) => {
      try {
        const formdata = new FormData();
        formdata.append("response", JSON.stringify(razorpayResponse));

        const url =
          sourcePage === "table"
            ? `${API_BASE_URL}/master/APIs/ClubTable/verifyRzpPayment`
            : `${API_BASE_URL}/master/APIs/ClubPackage/verifyRzpPayment`;

        const response = await axios.post(url, formdata);
        const verificationResponse = response.data;

        if (verificationResponse.status) {
          iziToast.success({
            title: "Success",
            message: verificationResponse.msg,
            timeout: 5000,
            position: "topCenter",
          });
          return true;
        } else {
          iziToast.error({
            title: "Error",
            message: verificationResponse.msg,
            timeout: 5000,
            position: "topCenter",
          });
          return false;
        }
      } catch (error) {
        console.error("Error verifying payment:", error);
        iziToast.error({
          title: "Error",
          message: "An error occurred while verifying the payment.",
          timeout: 5000,
          position: "topCenter",
        });
        return false;
      }
    },
    [sourcePage]
  );

  // ✅ On Mount
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude.toString());
          setLongitude(longitude.toString());
          createOrder(latitude, longitude);
          handleFetchCoupon();
        },
        (error) => {
          console.error("Error in finding location: ", error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, [createOrder]);

  if (loading) {
    return (
      // <div className="bid-order-summery-page">
      //   <div className="loading-container">
      //     <div className="loading-spinner"></div>
      //     <p>Creating your order...</p>
      //   </div>
      // </div>
      <Loader />
    );
  }

  if (error) {
    return (
      <div className="bid-order-summery-page">
        <div className="error-container">
          <div className="error-icon">⚠️</div>
          <h3>Oops! Something went wrong</h3>
          <p>{error}</p>
          <button onClick={createOrder} className="retry-btn">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (!orderData || !amounts) {
    return (
      <div className="bid-order-summery-page">
        <div className="error-container">
          <p>No order data available</p>
          <button onClick={() => navigate(-1)} className="back-btn">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="order-summery-page">
      <div className="price-summary-lead-info-section">
        <div className="pslis-container">
          <div className="top-title">
            <div className="top-title-left" onClick={()=>navigate(-1)} >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="14"
                viewBox="0 0 18 14"
                fill="none">
                <path
                  d="M17 7H1M1 7L7 1M1 7L7 13"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Price Summary
            </div>
          </div>
          <div className="pslis-card">
            <div className="pslis-left">
              {/* <div className="pslis-meta-row">
                <div className="pslis-label">
                  <h6>Party Summary</h6>
                </div>
              </div> */}

              <BlueCardInfoCard orderData={orderData} />

              <div className="pslis-meta-row">
                <div className="pslis-meta-left">{orderData?.title}</div>
                <div className="pslis-meta-right">
                  @₹{orderData?.male_amount} Per Person
                </div>
              </div>
            </div>

            <aside className="pslis-right">
              <VenueInfoComp orderData={orderData} />
            </aside>
          </div>
        </div>
      </div>

      {/* <div className="heading-set"></div> */}

      <div className="bid-order-summery-page">
        {/* Price Summary */}

        <div className="price-summary-card summary-amounts">
          <div className="d-flex align-items-start">
            <div className="summary-line total">
              <strong className="summary-line-final-price-text">
                Booking Amount (Book Now)
              </strong>
            </div>
            <div className="summary-line-pay-later">
              <strong className="summary-line-final-price-total">
                ₹{parseFloat(orderData.payable_amount || 0).toFixed(2)}
              </strong>
              <span className="ba-pl">
                Balance Amount (Pay later) : ₹{amounts.dueAmount.toFixed(2)}
              </span>
            </div>
          </div>

          <div className="pay-later-tag">
            <h1>Book now - pay later!!!</h1>
          </div>

          {/* Carrot Section */}

          <div className="carrot-section">
            <div className="carrot-header">
              <span>
                Available Carrot Balance:{" "}
                <span className="carrot-icon">🥕</span>{" "}
                {orderData?.remainingCarrot -
                  (useCarrot
                    ? parseFloat(amounts?.carrotDiscount || 0).toFixed(2)
                    : 0)}
              </span>
            </div>
            <label className="carrot-checkbox">
              <div className="carrot-checkbox-container">
                {amounts.usableCarrot > 0 && (
                  <input
                    type="checkbox"
                    checked={useCarrot}
                    onChange={(e) => setUseCarrot(e.target.checked)}
                  />
                )}
                <div className="carrot-checkbox-text">
                  <p className="carrot-checkbox-text-1">
                    Pay Using Carrot Balance
                  </p>
                  <p className="carrot-checkbox-text-2">
                    Use Carrot Balance 🥕 {amounts.usableCarrot}
                  </p>
                </div>
              </div>
              {/* {useCarrot && (
                  <span className="carrot-discount">(-₹{amounts.carrotDiscount.toFixed(2)})</span>
                )} */}
            </label>
          </div>

          <div className="pay-later-tag">
            {useCarrot ? (
              <h2>
                Great Choice! ₹
                {Number(amounts?.carrotDiscount) +
                  Number(amounts?.couponDiscount)}{" "}
                Saved Instantly on This Booking!
              </h2>
            ) : (
              <h2>Use Carrots! To Save on your Booking Amount</h2>
            )}
          </div>

          {/* Coupon Section */}

          <div className="coupon-section-container">
            <p>Coupons</p>
            <div className="coupon-section">
              <div className="coupon-input-group">
                <input
                  type="text"
                  className="coupon-input"
                  value={selectedCoupon?.code || ""}
                  placeholder="Enter coupon code"
                  readOnly
                />
                <button
                  className="coupon-btn"
                  onClick={() => setShowModal(true)}>
                  {selectedCoupon ? "Change" : "View Coupons"}
                </button>
              </div>
            </div>
          </div>
          {selectedCoupon && (
            <div className="coupon-applied">
              <div className="d-flex gap-2">
                <div className="w-auto">
                  <label className="cc-box">
                    <input type="checkbox" defaultChecked="checked" />
                    <span className="checkmark" />
                  </label>
                </div>
                <div className="coupon-discount">
                  <h5>
                    You have saved ₹{amounts.couponDiscount.toFixed(2)}{" "}
                    <span className="text-primary">{selectedCoupon?.code || ""}</span>
                  </h5>
                  <p>
                    View All Coupons{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="10"
                      viewBox="0 0 13 10"
                      fill="none">
                      <path
                        d="M1 5H12M12 5L7.875 1M12 5L7.875 9"
                        stroke="#4F4F4F"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </p>
                </div>
              </div>

              <button onClick={handleRemoveCoupon} className="remove-coupon">
                Remove
              </button>
            </div>
          )}

          <div className="ordersummer-content-page">
            <div className="summary-line">
              <span>Booking Amount (Advance)</span>
              <span>
                ₹{parseFloat(orderData.payable_amount || 0).toFixed(2)}
              </span>
            </div>

            <div className="summary-line-platform">
              <PlatformChargesTooltip
                content={
                  <div className="platform-charges-tooltip">
                    {/* <p className='platform-charges-tooltip-text'><span>GST On Party Amount</span><span>₹400.00</span></p> */}
                    <p className="platform-charges-tooltip-text">
                      <span>Platform Charges</span>
                      <span>₹5.00</span>
                    </p>
                    <p className="platform-charges-tooltip-text">
                      <span>GST On Platform</span>
                      <span>₹0.90</span>
                    </p>
                    <hr />
                    <p className="platform-charges-tooltip-text">
                      <strong>Total</strong>
                      <strong>₹5.90</strong>
                    </p>
                  </div>
                }>
                <span className="order-summery-other-charges">
                  Platform & Other Charges
                </span>
              </PlatformChargesTooltip>
              {/* <span className='order-summery-other-charges'>Platform & Other Charges</span> */}
              <span>₹5.90</span>
            </div>
            <div className="summary-line gt">
              <strong>Grand Total</strong>
              <strong>
                {selectedCoupon?.id === initialValuesCoupon?.id
                  ? `₹${parseFloat(
                      Number(orderData?.payable_amount) +
                        Number(orderData?.platform_fee) || 0
                    ).toFixed(2)}`
                  : `₹${amounts?.netPayableAmount.toFixed(2)}`}
              </strong>
            </div>
          </div>

          {amounts.carrotDiscount > 0 && (
            <div className="summary-line">
              <span className="order-summery-carrot">Used Carrots</span>
              <span className="order-summery-carrot">
                -₹{amounts.carrotDiscount.toFixed(2)}
              </span>
            </div>
          )}

          {amounts.couponDiscount > 0 && (
            <div className="summary-line">
              <span>Coupon Discount</span>
              <span className="order-summery-coupon">
                -₹{amounts.couponDiscount.toFixed(2)}
              </span>
            </div>
          )}

          {(amounts.carrotDiscount > 0 || amounts.couponDiscount > 0) && (
            <div className="summary-line ap">
              <strong>Amount Payable</strong>
              <strong className="final-price">
                ₹{amounts.finalPayableAmount.toFixed(2)}
              </strong>
            </div>
          )}
        </div>
      </div>
      <div className="proceed-to-payment-section">
        <div className="proceed-to-payment-wrapper">
          <button
            className="order-proceed-btn"
            onClick={handleProceedToCheckout}
            disabled={!orderData?.order_id}>
            {amounts.carrotDiscount > 0 || amounts.couponDiscount > 0 ? (
              <div className="">
                <span>₹{amounts.finalPayableAmount.toFixed(2)}</span>
              </div>
            ) : (
              <div className="">
                <span>₹{amounts.netPayableAmount.toFixed(2)}</span>
              </div>
            )}{" "}
            Proceed to Payment
          </button>
        </div>
      </div>

      {/* Coupon Modal */}
      <CouponModal
        show={showModal}
        onClose={() => setShowModal(false)}
        availableCoupons={availableCoupons}
        onApplyCoupon={handleCouponApply}
        selectedCoupon={selectedCoupon}
        orderAmount={amounts?.payableAmount || 0}
      />
    </div>
  );
};

export default OrderSummary;
